const { createSlice } = require('@reduxjs/toolkit');

const userSlice = createSlice({
    name: "user",
    initialState: {
        token: null,
        profile: null
    },
    reducers: {
        setUser(state, action) {
            state.token = action.payload.token;
            state.profile = action.payload.user;
        },
        logout(state) {
            state.token = null;
            state.profile = null;
        }
    },
});

export const { setUser, logout } = userSlice.actions;
export default userSlice.reducer;
